import React, { PureComponent } from 'react';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Switch from "housecall-ui/dist/DesignSystem/Inputs/Switches/Switch";
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';

const styles = () => ({
  toggleLabel: {
    position: 'relative',
    top: 1,
    lineHeight: 1,
  },
  toggleContainer: {
    display: 'flex',
    height: 48,
    alignItems: 'center',
  },
});

let timeoutReference

@withStyles(styles)
export default class ActionToggle extends PureComponent {

  constructor(props) {
    super(props)
    this.state = { disabled: false }
  }

  onClickWrapper(...args) {
    const { onClick } = this.props
    this.setState({ disabled: true })
    onClick(...args)
      .then(() => this.setState({ disabled: false }))
  }

  renderToggle() {
    const {
      classes: {
        toggleContainer,
        toggleLabel,
      },
      enabled,
      hideToggle,
      buttonColor,
      buttonText,
      canUseApp,
    } = this.props;

    const { disabled } = this.state

    if (!hideToggle && canUseApp) {
      return (
        <div className={toggleContainer}>
          <Switch
            disabled={disabled}
            checked={enabled}
            onChange={(...args) => this.onClickWrapper(...args)}
          />
          <Typography
            align="right"
            component="div"
            className={toggleLabel}
            style={{color: buttonColor}}
            variant="body1"
          >
            {buttonText}
          </Typography>
        </div>
      );
    }

    return null;
  }

  componentWillUnmount() {
    clearTimeout(timeoutReference)
  }

  render() {
    const toggle = this.renderToggle();

    return (
      <Grid item>
        {toggle}
      </Grid>
    );
  }
}
